import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import tr from "./locales/tr.json";

// If the URL contains ?lng=tr|en (used by admin preview iframes), we should
// honour it but NOT persist it to localStorage — otherwise opening the preview
// would silently change the user's normal language preference.
const hasUrlLang =
  typeof window !== "undefined" &&
  /[?&]lng=(tr|en)\b/i.test(window.location.search);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr },
    },
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      // querystring first so admin preview iframes (?lng=tr / ?lng=en)
      // can pin a language independent of the parent window.
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
      // Skip caching whenever the language was forced via URL.
      caches: hasUrlLang ? [] : ["localStorage"],
    },
  });

export default i18n;
